// extracted by mini-css-extract-plugin
export default {"container":"DoubleVisualMediaContainer__container___QgZH5","image":"DoubleVisualMediaContainer__image___viJCI"};